// extracted by mini-css-extract-plugin
export var container = "v3-useful-infos-module--container--df263";
export var emptyLeftPart = "v3-useful-infos-module--emptyLeftPart--ce771";
export var paragraphs = "v3-useful-infos-module--paragraphs--991c1";
export var title = "v3-useful-infos-module--title--9928d";
export var usefulInfosWrapper = "v3-useful-infos-module--usefulInfosWrapper--e0b92";